<p>usre-avatar works!</p>
